<div class="container-fluid" [formGroup]="contactUsForm" *ngIf="contactUsForm">
    <div class="row" *ngIf="!isMailSent">
        <div class="col-xl-8 col-md-10 col-12">
            <p class="company-description mb-10">{{ 'CONTACT_US_PAGE.LABELS.COMPANY_DESCRIPTION' | transloco }}</p>
            <div class="row mb-3">
                <div class="col">
                    <mat-label class="font-style">
                        <!-- Your Message -->
                        {{ 'CONTACT_US_PAGE.LABELS.YOUR_MESSAGE' | transloco }}<span class="text-danger">*</span>
                    </mat-label>
                    <mat-form-field class="example-full-width custom-text-field" appearance="outline" [floatLabel]="'never'">
                        <textarea
                            rows="3"
                            (keypress)="fromControlsValidationHandler($event, 2)"
                            (paste)="fromControlsValidationHandler($event, 4)"
                            formControlName="inquireyMessage"
                            type="text"
                            matInput
                            autocomplete="new-password"
                        ></textarea>
                    </mat-form-field>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-md-6">
                    <mat-label class="font-style">
                        <!-- Topic -->
                        {{ 'CONTACT_US_PAGE.LABELS.TOPIC' | transloco }}<span class="text-danger">*</span>
                    </mat-label>
                    <mat-select
                        formControlName="topic"
                        class="contact-us-drop-down dropdown-wrapper"
                        panelClass="dropdown-wrapper"
                        placeholder="{{ 'CONTACT_US_PAGE.INPUT_PLACEHOLDER.PLEASE_SELECT' | transloco }}"
                    >
                        <ng-container *transloco="let t; read: 'CONTACT_US_PAGE.TOPIC_LIST'">
                            <mat-option class="drop-options" value="{{ topic }}" *ngFor="let topic of topicList"> {{ t(topic) }} </mat-option>
                        </ng-container>
                    </mat-select>
                </div>
                <div class="col-md-6" *ngIf="isProductDropDownList">
                    <mat-label class="font-style"> {{ 'CONTACT_US_PAGE.LABELS.PRODUCT_TYPE' | transloco }}<span class="text-danger">*</span> </mat-label>
                    <mat-select
                        formControlName="productType"
                        class="contact-us-drop-down dropdown-wrapper"
                        panelClass="dropdown-wrapper"
                        placeholder="{{ 'CONTACT_US_PAGE.INPUT_PLACEHOLDER.PLEASE_SELECT' | transloco }}"
                    >
                        <ng-container *transloco="let t; read: 'CONTACT_US_PAGE.PRODUCTS_LIST'">
                            <mat-option class="drop-options" value="{{ t(product) }}" *ngFor="let product of productList"> {{ t(product) }} </mat-option>
                        </ng-container>
                    </mat-select>
                </div>
                <div class="col-md-6" *ngIf="isServiceDropDownList">
                    <mat-label class="font-style">
                        <!-- Service Type  -->
                        {{ 'CONTACT_US_PAGE.LABELS.SERVICE_TYPE' | transloco }}<span class="text-danger">*</span>
                    </mat-label>
                    <mat-select
                        formControlName="serviceType"
                        class="contact-us-drop-down dropdown-wrapper"
                        panelClass="dropdown-wrapper"
                        placeholder="{{ 'CONTACT_US_PAGE.INPUT_PLACEHOLDER.PLEASE_SELECT' | transloco }}"
                    >
                        <ng-container *transloco="let t; read: 'CONTACT_US_PAGE.SERVICE_TYPE'">
                            <mat-option class="drop-options" value="{{ t(service) }}" *ngFor="let service of serviceList"> {{ t(service) }} </mat-option>
                        </ng-container>
                    </mat-select>
                </div>
            </div>
            <!-- User Details -->
            <div class="row">
                <div class="col-md-6 mb-3">
                    <mat-label class="font-style">
                        <!-- First Name -->
                        {{ 'CONTACT_US_PAGE.LABELS.FIRST_NAME' | transloco }}<span class="text-danger">*</span>
                    </mat-label>
                    <mat-form-field class="example-full-width custom-text-field" [color]="'#000000'" appearance="outline" [floatLabel]="'never'">
                        <input
                            type="text"
                            (keypress)="fromControlsValidationHandler($event, 1)"
                            (paste)="fromControlsValidationHandler($event, 5)"
                            formControlName="firstName"
                            placeholder="{{ 'CONTACT_US_PAGE.INPUT_PLACEHOLDER.FIRST_NAME' | transloco }}"
                            matInput
                            autocomplete="new-password"
                        />
                    </mat-form-field>
                </div>
                <div class="col-md-6 mb-3">
                    <mat-label class="font-style">
                        <!-- Last Name -->
                        {{ 'CONTACT_US_PAGE.LABELS.LAST_NAME' | transloco }}<span class="text-danger">*</span>
                    </mat-label>
                    <mat-form-field class="example-full-width custom-text-field" appearance="outline" [floatLabel]="'never'">
                        <input
                            type="text"
                            (keypress)="fromControlsValidationHandler($event, 1)"
                            (paste)="fromControlsValidationHandler($event, 5)"
                            formControlName="lastName"
                            placeholder="{{ 'CONTACT_US_PAGE.INPUT_PLACEHOLDER.LAST_NAME' | transloco }}"
                            matInput
                            autocomplete="new-password"
                        />
                    </mat-form-field>
                </div>
                <div class="col-md-6 mb-3">
                    <mat-label class="font-style">
                        <!-- Email -->
                        {{ 'CONTACT_US_PAGE.LABELS.EMAIL' | transloco }}<span class="text-danger">*</span>
                    </mat-label>
                    <mat-form-field class="example-full-width custom-text-field" appearance="outline" [floatLabel]="'never'">
                        <input
                            type="email"
                            formControlName="email"
                            placeholder="{{ 'CONTACT_US_PAGE.INPUT_PLACEHOLDER.EMAIL' | transloco }}"
                            matInput
                            autocomplete="new-password"
                        />
                    </mat-form-field>
                </div>
                <div class="col-md-6 mb-3">
                    <mat-label class="font-style">
                        <!-- Phone -->
                        {{ 'CONTACT_US_PAGE.LABELS.PHONE' | transloco }}<span class="text-danger">*</span>
                    </mat-label>
                    <mat-form-field class="example-full-width custom-text-field" appearance="outline" [floatLabel]="'never'">
                        <input
                            type="text"
                            (keypress)="fromControlsValidationHandler($event, contactUsValidation.ResSpecialCharAndCharExceptPlusHyphen)"
                            (paste)="fromControlsValidationHandler($event, contactUsValidation.PasteSpecialCharExceptHyphenPlusNumber)"
                            formControlName="phone"
                            placeholder="{{ 'CONTACT_US_PAGE.INPUT_PLACEHOLDER.PHONE' | transloco }}"
                            matInput
                            autocomplete="new-password"
                        />
                    </mat-form-field>
                </div>
                <div class="col-md-6 mb-3">
                    <mat-label class="font-style">
                        <!-- Company Name -->
                        {{ 'CONTACT_US_PAGE.LABELS.COMPANY' | transloco }}<span class="text-danger">*</span>
                    </mat-label>
                    <mat-form-field class="example-full-width custom-text-field" appearance="outline" [floatLabel]="'never'">
                        <input
                            type="text"
                            (keypress)="fromControlsValidationHandler($event, contactUsValidation.ResSpecialChar)"
                            (paste)="fromControlsValidationHandler($event, contactUsValidation.PasteSpecialChar)"
                            formControlName="company"
                            placeholder="{{ 'CONTACT_US_PAGE.INPUT_PLACEHOLDER.COMPANY' | transloco }}"
                            matInput
                            autocomplete="new-password"
                        />
                    </mat-form-field>
                </div>
                <div class="col-md-6 mb-3">
                    <mat-label class="font-style">
                        <!-- Address  -->
                        {{ 'CONTACT_US_PAGE.LABELS.ADDRESS' | transloco }}<span class="text-danger">*</span>
                    </mat-label>
                    <mat-form-field class="example-full-width custom-text-field" appearance="outline" [floatLabel]="'never'">
                        <input
                            type="text"
                            (keypress)="fromControlsValidationHandler($event, contactUsValidation.AddressRestriction)"
                            (paste)="fromControlsValidationHandler($event, contactUsValidation.PasteRestrictionAddress)"
                            formControlName="address"
                            placeholder="{{ 'CONTACT_US_PAGE.INPUT_PLACEHOLDER.ADDRESS' | transloco }}"
                            matInput
                            autocomplete="new-password"
                        />
                    </mat-form-field>
                </div>
                <div class="col-md-6 mb-3">
                    <mat-label class="font-style">
                        <!-- City -->
                        {{ 'CONTACT_US_PAGE.LABELS.CITY' | transloco }}<span class="text-danger">*</span>
                    </mat-label>
                    <mat-form-field class="example-full-width custom-text-field" appearance="outline" [floatLabel]="'never'">
                        <input
                            type="text"
                            (keypress)="fromControlsValidationHandler($event, contactUsValidation.AddressRestriction)"
                            (paste)="fromControlsValidationHandler($event, contactUsValidation.PasteRestrictionAddress)"
                            formControlName="city"
                            placeholder="{{ 'CONTACT_US_PAGE.INPUT_PLACEHOLDER.CITY' | transloco }}"
                            matInput
                            autocomplete="new-password"
                        />
                    </mat-form-field>
                </div>
                <div class="col-md-6 mb-3">
                    <mat-label class="font-style">
                        <!-- Zip or Postal Code -->
                        {{ 'CONTACT_US_PAGE.LABELS.ZIP_CODE' | transloco }}<span class="text-danger">*</span>
                    </mat-label>
                    <mat-form-field class="example-full-width custom-text-field" appearance="outline" [floatLabel]="'never'">
                        <input
                            type="text"
                            (keypress)="fromControlsValidationHandler($event, contactUsValidation.PostalCodeRestriction)"
                            (paste)="fromControlsValidationHandler($event, contactUsValidation.PasteRestrictionForPostalCode)"
                            formControlName="zipCode"
                            placeholder="{{ 'CONTACT_US_PAGE.INPUT_PLACEHOLDER.ZIP_CODE' | transloco }}"
                            matInput
                            autocomplete="new-password"
                        />
                    </mat-form-field>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-md-6">
                    <mat-label class="font-style">
                        <!-- Country  -->
                        {{ 'CONTACT_US_PAGE.LABELS.COUNTRY' | transloco }}<span class="text-danger">*</span>
                    </mat-label>
                    <!-- <mat-form-field class="example-full-width no-line" appearance="outline"> -->
                    <mat-select
                        formControlName="country"
                        class="contact-us-drop-down dropdown-wrapper"
                        panelClass="dropdown-wrapper"
                        placeholder="{{ 'CONTACT_US_PAGE.INPUT_PLACEHOLDER.PLEASE_SELECT' | transloco }}"
                    >
                        <ng-container *transloco="let t; read: 'ORG_DETAILS.COUNTRY'">
                            <mat-option class="drop-options" value="{{ t(country) }}" *ngFor="let country of countryList"> {{ t(country) }} </mat-option>
                        </ng-container>
                    </mat-select>
                    <!-- </mat-form-field> -->
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-md-6">
                    <mat-label class="font-style">
                        <!-- Industry -->
                        {{ 'CONTACT_US_PAGE.LABELS.INDUSTRY' | transloco }}<span class="text-danger">*</span>
                    </mat-label>
                    <!-- <mat-form-field class="example-full-width no-line" appearance="outline"> -->
                    <mat-select
                        formControlName="industry"
                        class="contact-us-drop-down dropdown-wrapper"
                        panelClass="dropdown-wrapper"
                        placeholder="{{ 'CONTACT_US_PAGE.INPUT_PLACEHOLDER.PLEASE_SELECT' | transloco }}"
                    >
                        <ng-container *transloco="let t; read: 'CONTACT_US_PAGE.INDUSTRY_LIST'">
                            <mat-option class="drop-options" value="{{ t(industry) }}" *ngFor="let industry of industryList">
                                {{ t(industry) }}
                            </mat-option>
                        </ng-container>
                    </mat-select>
                    <!-- </mat-form-field> -->
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-md-12 mb-5">
                    <mat-checkbox formControlName="subscriptionCheck" (change)="handleCheckboxChange($event)" class="example-margin font-size-16 checkbox-wrap">
                        <!-- I would like to receive service updates and emails from Hydratight and Enerpac -->
                        {{ 'CONTACT_US_PAGE.LABELS.EMAIL_SUBSCRIPTION' | transloco }}
                    </mat-checkbox>
                </div>
                <!-- Captcha Controller -->
                <div class="col-md-12 mb-5">
                    <!-- <re-captcha formControlName="captchaCode" (resolved)="handleCaptchaEvents($event, 0)" (expire)="handleCaptchaEvents($event, 1)">
                    </re-captcha> -->
                    <div class="col-md-12 mb-5">
  <div
    class="g-recaptcha"
    #captchaRef>
  </div>
</div>
                </div>

                <div class="col-md-12 mb-5">
                    <button
                        type="button"
                        class="btn primary-ebtn me-3"
                        [ngClass]="!contactUsForm.valid ? 'cursor-not-allow' : ''"
                        [disabled]="!contactUsForm.valid"
                        (click)="sendEmail()"
                    >
                        <!-- Submit  -->
                        {{ 'CONTACT_US_PAGE.LABELS.SUBMIT' | transloco }}
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div class="row" *ngIf="isMailSent">
        <div class="col success-screen">
            <h1>
                <!-- Thank you for contacting us -->
                {{ 'CONTACT_US_PAGE.LABELS.THANKS_MESSAGE' | transloco }}
            </h1>
            <p>
                <!-- Your Submission has been received. We will be in contact with you shortly. -->
                {{ 'CONTACT_US_PAGE.LABELS.SUBMISSION_RESPONSE' | transloco }}
            </p>
        </div>
    </div>
</div>
